// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.locationsBlock__Oo2xn {
  overflow-y: auto;
  padding-bottom: 2px;
  background-color: var(--tables-secondary-row-sub-title-surface);
}
.locationsBlock__Oo2xn::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.locationsBlock__Oo2xn::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.locationsBlock__Oo2xn::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.locationsBlock__Oo2xn::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.locationItem__NFwUA {
  padding: 0 20px 15px;
}
.locationItem__NFwUA:not(:first-child) {
  border-top: 1px solid var(--tables-primary-row-stroke);
}

.locationName__q7BtT {
  font-size: 11px;
  font-weight: 600;
  line-height: 12px;
  color: var(--tables-secondary-row-sub-title-text);
  text-transform: uppercase;
  padding: 16px 0px 17px;
}

.sensorsBlock___m4iy {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding-left: 1px;
}

.emptyBlockWrapper__WkHoz {
  background-color: var(--tables-secondary-row-sub-title-surface);
}

.skeletonEquipmentItem__RiW62 {
  width: 100%;
  height: 155px;
  max-width: 320px;
  padding: 13px 25px;
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  background-color: var(--tables-primary-row-surface-default);
  box-shadow: var(--basic-box-shadow);
}

.skeletonTitle__qOz8e {
  width: 100%;
  height: 12px;
  max-width: 680px;
}

.skeletonText__KH9eN {
  height: 20px;
}

.skeletonItems__NtJV5 {
  height: 39px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Sensors/components/SensorsLocations/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,gBAAA;EACA,mBAAA;EACA,+DAAA;AAzEF;AAsBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AApBJ;AAuBE;EACE,+BAAA;EACA,kBAAA;AArBJ;AAwBE;EACE,8BAAA;EACA,kBAAA;AAtBJ;AAyBE;EACE,gBAAA;EACA,kBAAA;AAvBJ;;AA6DA;EACE,oBAAA;AA1DF;AA4DE;EACE,sDAAA;AA1DJ;;AA8DA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,yBAAA;EACA,sBAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;AA3DF;;AA8DA;EACE,+DAAA;AA3DF;;AA8DA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,2DAAA;EACA,mCAAA;AA3DF;;AA8DA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AA3DF;;AA8DA;EACE,YAAA;AA3DF;;AA8DA;EACE,YAAA;AA3DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.locationsBlock {\n  overflow-y: auto;\n  padding-bottom: 2px;\n  background-color: var(--tables-secondary-row-sub-title-surface);\n\n  @include scrollBar;\n}\n\n.locationItem {\n  padding: 0 20px 15px;\n\n  &:not(:first-child) {\n    border-top: 1px solid var(--tables-primary-row-stroke);\n  }\n}\n\n.locationName {\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 12px;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-transform: uppercase;\n  padding: 16px 0px 17px;\n}\n\n.sensorsBlock {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  padding-left: 1px;\n}\n\n.emptyBlockWrapper {\n  background-color: var(--tables-secondary-row-sub-title-surface);\n}\n\n.skeletonEquipmentItem {\n  width: 100%;\n  height: 155px;\n  max-width: 320px;\n  padding: 13px 25px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 25px;\n  background-color: var(--tables-primary-row-surface-default);\n  box-shadow: var(--basic-box-shadow);\n}\n\n.skeletonTitle {\n  width: 100%;\n  height: 12px;\n  max-width: 680px;\n}\n\n.skeletonText {\n  height: 20px;\n}\n\n.skeletonItems {\n  height: 39px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"locationsBlock": `locationsBlock__Oo2xn`,
	"locationItem": `locationItem__NFwUA`,
	"locationName": `locationName__q7BtT`,
	"sensorsBlock": `sensorsBlock___m4iy`,
	"emptyBlockWrapper": `emptyBlockWrapper__WkHoz`,
	"skeletonEquipmentItem": `skeletonEquipmentItem__RiW62`,
	"skeletonTitle": `skeletonTitle__qOz8e`,
	"skeletonText": `skeletonText__KH9eN`,
	"skeletonItems": `skeletonItems__NtJV5`
};
module.exports = ___CSS_LOADER_EXPORT___;
